import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const IssueLogSearchParamsSchema = createPaginationSchema().concat(
  createSortSchema([
    'createdOn',
    'reportedByName',
    'orderReferenceNumber',
    'productName',
    'issueType',
    'buyerSiteName',
    'distributorName',
  ] as const)
);
